// The capture keys of the Disposition & handoff tab (CAPTURE.md H1/H5; PLAN D18 and T-8: lane B9 owns the `close` and
// `hris` prefixes). Product code passes each key as a string, or a template with its owned static head
// (`close.item.${slug(app)}.${slug(key)}`), never through a map; a frame spec numbers them in its own tour order
// (frames 21-7…), so one screen serves every frame that photographs it. `slug` is the one record-id-to-key reading.

export const slug = (value: string) => value.replace(/[^a-z0-9]+/gi, "-").replace(/^-|-$/g, "").toLowerCase();
